function applyTheme(mode) {
    if (mode == 'light') document.body.classList.add('whitemode');
    else document.body.classList.remove('whitemode')
}

export function changeTheme(switchName) {
    let dialog = document.querySelector("app-dialog");
    if (!dialog){
        console.error("dialog component not found");
        return;
    } else {
        dialog = dialog.shadowRoot;
        let darkmodeSwitch = dialog.querySelector(`#${switchName}`);
        if (!darkmodeSwitch) {
            console.error(`switch "${switchName}" not found`);
            return;
        } else {
            if (darkmodeSwitch.checked){
                localStorage.setItem('theme', 'dark');
                applyTheme('dark');
            } else {
                localStorage.setItem('theme', 'light');
                applyTheme('light');
            }
        }
    }
}

export function loadThemeBasedOnSwitch(switchElement) {
    const darkModeSetting = localStorage.getItem("theme") || "false";
    if (darkModeSetting == "light") {
        switchElement.checked = false;
    } else {
        switchElement.checked = true;
    }
    changeTheme("darkModeCheck");
}

applyTheme(localStorage.getItem('theme'))